function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1567.000000, -637.000000)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1328.000000, 339.000000)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M243.99904,297.226042 C243.75027,296.94389 243.326544,296.923036 243.052857,297.1795 C243.03705,297.194278 243.022046,297.209884 243.007712,297.226042 L240.17439,300.439788 C239.925352,300.72194 239.945446,301.15891 240.219267,301.415513 C240.492954,301.672253 240.91668,301.651399 241.165717,301.369247 L242.83356,299.470278 L242.83356,306.309466 C242.83356,306.690641 243.133503,307 243.503376,307 C243.873382,307 244.173192,306.690641 244.173192,306.309466 L244.173192,299.484089 L245.834336,301.369247 C246.083373,301.651399 246.507099,301.672253 246.780786,301.415513 C247.054607,301.15891 247.074567,300.72194 246.825664,300.439788 L243.99904,297.226042 Z",
  transform: "translate(243.500000, 302.000000) rotate(-315.000000) translate(-243.500000, -302.000000) "
})));

function SvgIcArrowTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "8px",
    viewBox: "0 0 9 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowTopRight);
export default __webpack_public_path__ + "static/media/ic-arrow-top-right.72c1952e.svg";
export { ForwardRef as ReactComponent };